export enum FeedbackType {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  CONFIRMATION = "CONFIRMATION",
  INSTRUMENT_TECHNICIAN = "INSTRUMENT_TECHNICIAN",
}
